module.exports = __webpack_public_path__ + "img/regular.21fe5dd9.svg";